<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/chertgpt-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">AI产品及解决方案</h2>
							<h4 class="text-left color-white">AI驱动企业数字化转型</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">CherGPT—AI原生赋能平台</h2>
				<div style="margin-top: 48px; font-size: 18px">
					整合企业算力、模型、知识、应用四大核心要素，全面优化AI模型在选型、训练、应用、管理四大阶段的流程，CherGPT旨在为企业数智化转型打造一条完整的AI智能应用工程生产线。该生产线包含三大核心模块：模型算力管理平台、企业私域知识管理平台、以及AI应用工程平台。CherGPT不仅为企业提供更为先进且贴合需求的大模型，还解决了算力领域的信创适配、融合调度难题，以及企业私域大模型的高效推理与训练挑战。同时，它有效实现了数据向知识的向量化转化，并简化了场景应用的轻量化组装流程，为企业数智化进程注入了强劲动力。
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">产品优势</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">异构算力统一纳管</div>
										<div class="t1">模型算力全面优化</div>
										<div class="t2">CherGPT支持信创/非信创、多品牌CPU与GPU异构多端算力的统一管理，解决大模型算力技术瓶颈，可根据模型、芯片类型，弹性调度，提高关键核心算力GPU使用效率。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">国内外主流模型一键调用</div>
										<div class="t1">企业私有模型高效微调训练</div>
										<div class="t2">提供40+基础大模型，可根据业务需求灵活选择开发应用，尝试最佳实践效果。CherGPT提供完整私有模型微调训练工具集，帮助企业定制专属大模型，解决模型应用准确率低的问题。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多模态多层级知识库权限管理</div>
										<div class="t1">激活企业数据资产</div>
										<div class="t2">CherGPT支持文本、图片、音视频、网页等结构化与非结构化知识格式有效整合， 可结合访问权限进行管理控制，保障数据安全，打造企业级私域知识库。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">多种应用构建方式</div>
										<div class="t1">灵活适配开箱即用</div>
										<div class="t2">根据企业实际情况提供多种可选配置方式，多种应用开发模式，无缝融合企业业务系统。CherGPT预置了多种企业级应用场景模板，高效解决企业开发使用应用的各种难题。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/chergpt1.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<separator />

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">适用场景</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="pic">
						<img src="@/assets/images/bwt/chergpt2.jpg" style="border-radius: 12px;">
					</div>
					<div class="txt">
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">算力部署</div>
										<div class="t2">支持多品牌异构算力动态调度，支持公有云、私有云的部署方式，支持定制开发服务，满足企业多样化需求。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">模型训练</div>
										<div class="t2">提供零代码模型训练配置方式，支持加速引擎、模型量化、模型压缩等推理加速技术，帮助企业降低推理延迟、节省资源，增强大模型稳定性与可靠性。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数据治理</div>
										<div class="t2">企业大数据平台长期受限于仅处理业务系统内的结构化数据，大量非结构化数据因成本与效率问题未充分利用。借助CherGPT实现全面数据治理，最大化释放既有大数据平台的价值。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">知识问答</div>
										<div class="t2">通过自然语言交互的形式，结合企业私域知识库训练的私有大模型应用，能够理解、记忆和推理业务问题，全面精准地回答用户提问。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">文案写作</div>
										<div class="t2">内置企业级经典文案写作模板，仅需填写必要信息，即可编写高质量的文案。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">文档阅读</div>
										<div class="t2">支持将文件一键生成纲要总结，可通过对话的方式精读和提问文档相关内容</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">文档解析</div>
										<div class="t2">支持将文档批量处理成指定格式，为构建数据资产提供便利。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">内容翻译</div>
										<div class="t2">通过自然语言交互的形式，支持多种语言的纠错、正反译，助力企业业务出海。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">文生图</div>
										<div class="t2">通过自然语言描述，自动生成高质量图片，支持专业图像参数（如拍摄角度、光影特效、布局等）的提示词识别，实现从文字到视觉艺术的创造性转化。</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">智能客服</div>
										<div class="t2">通过自然语言交互，全天候提供咨询、办理、查询等服务。用户需求秒级响应，提升服务效率与满意度，减轻人工客服负担。</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 50%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}
.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		margin-top: 10%;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
